import React from "react";
import { useGerenciamento } from "../../Context/GerenciamentoContext";
import "./Titulo.css";

export default function Titulo() {
  const { modulo } = useGerenciamento();

  if (!modulo) {
    return(
    <div className="Titulo-container">
      <h2 className="Titulo-text">Gerenciamento </h2>
      <div className="Titulo-linha"></div>
    </div>
  );
  }

  const tituloFormatado =
   // modulo.charAt(0).toUpperCase() + modulo.slice(1);
    modulo.label;

  return (
    <div className="Titulo-container">
      <h2 className="Titulo-text">Gerenciamento de <br/>{tituloFormatado}</h2>
      <div className="Titulo-linha"></div>
    </div>
  );
}
